module.exports = __webpack_public_path__ + "img/shuffle.c21aa90b.svg";